{
  "test": {
    "enable_resource_bundle_mock": false
  },
  "stage": {
    "enable_resource_bundle_mock": false
  },
  "preprod": {
    "enable_resource_bundle_mock": false
  },
  "prod": {
    "enable_resource_bundle_mock": false
  }
}
